import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {ShadowType} from '../../../../incase-domain/common/elementShadow';
import Button from '../../../../incase-domain/components/button/Button';
import DropdownMenuCompact from '../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import {IElementBase} from '../../../../incase-domain/elements/base/elementBase';
import SectionTitle from '../../../elements/common/SectionTitle';

interface ElementShadowProps<T extends IElementBase> {
    highlightedElement: T;
    highlightedElementChangeHandler: {
        single: <K extends keyof T>(field: K, value: T[K]) => void;
    };
}

function ElementShadow<T extends IElementBase>(props: ElementShadowProps<T>): ReactElement {
    const {highlightedElement, highlightedElementChangeHandler} = props;

    const {t} = useTranslation();

    const OPTIONS = [
        {
            label: t(`elementShadow.${ShadowType.NONE}`),
            value: ShadowType.NONE,
            onClick: () => highlightedElementChangeHandler.single('boxShadow', ShadowType.NONE),
        },
        {
            label: t(`elementShadow.${ShadowType.SMALL}`),
            value: ShadowType.SMALL,
            onClick: () => highlightedElementChangeHandler.single('boxShadow', ShadowType.SMALL),
        },
        {
            label: t(`elementShadow.${ShadowType.MEDIUM}`),
            value: ShadowType.MEDIUM,
            onClick: () => highlightedElementChangeHandler.single('boxShadow', ShadowType.MEDIUM),
        },
        {
            label: t(`elementShadow.${ShadowType.LARGE}`),
            value: ShadowType.LARGE,
            onClick: () => highlightedElementChangeHandler.single('boxShadow', ShadowType.LARGE),
        },
    ];

    return (
        <div className="l-group--form">
            <div className="l-group__item ">
                <SectionTitle label={t('elementShadow.title')} />
                <DropdownMenuCompact className="c-sidepanel__dropdown" width="full" items={[[...OPTIONS]]}>
                    <Button
                        variant="soft"
                        size="xs"
                        fullWidth
                        trailing="solar:alt-arrow-down-linear"
                        className="c-sidepanel__dropdown_button"
                    >
                        {OPTIONS.find((val) => val.value === highlightedElement.boxShadow)?.label ||
                            t('presEditPage.editSidebar.elements.selectPlaceholder')}
                    </Button>
                </DropdownMenuCompact>
            </div>
        </div>
    );
}

export default ElementShadow;
